export enum ModalActionType {
  Create = 'Create',
  Edit = 'Edit',
}
